export type LiveStageRole = 'host' | 'cohost' | 'speaker' | 'backstage';
export type LiveModerationState = 'active' | 'removed';

export interface LiveOperatorPolicy {
  stageAccess: 'open' | 'locked';
  publicChat: 'open' | 'operators_only';
}

export const DEFAULT_LIVE_OPERATOR_POLICY: LiveOperatorPolicy = {
  stageAccess: 'open',
  publicChat: 'open',
};

export const LIVE_STAGE_ROLE_LABELS: Record<LiveStageRole, string> = {
  host: 'Host',
  cohost: 'Co-host',
  speaker: 'Speaker',
  backstage: 'Backstage',
};

export function resolveLiveOperatorPolicy(
  policy?: Partial<LiveOperatorPolicy> | null,
): LiveOperatorPolicy {
  return {
    stageAccess: policy?.stageAccess === 'locked' ? 'locked' : 'open',
    publicChat: policy?.publicChat === 'operators_only' ? 'operators_only' : 'open',
  };
}

export function isLiveOperatorRole(role: LiveStageRole): boolean {
  return role === 'host' || role === 'cohost';
}

export function isStageVisibleRole(role: LiveStageRole): boolean {
  return role !== 'backstage';
}

interface ResolveLiveStageRoleOptions {
  userId: string;
  hostId: string;
  assignedRole?: LiveStageRole;
  moderationState?: LiveModerationState;
  policy?: Partial<LiveOperatorPolicy> | null;
}

export function resolveLiveStageRole({
  userId,
  hostId,
  assignedRole,
  moderationState,
  policy,
}: ResolveLiveStageRoleOptions): LiveStageRole {
  if (userId === hostId) return 'host';
  if (moderationState === 'removed') return 'backstage';
  if (assignedRole) return assignedRole;

  const normalizedPolicy = resolveLiveOperatorPolicy(policy);
  return normalizedPolicy.stageAccess === 'locked' ? 'backstage' : 'speaker';
}
